const fr = {
  global: {
    title: "PERMUTEO",
    select_all: "Tous les services"
  },
  format: {
    date_at_time: "DD/MM/YYYY [à] HH[H]mm",
    date: "DD/MM/YYYY",
    show_date_form: 'DD-MM-YYYY',
    save_date_form: 'YYYY-MM-DD',
    date_time: 'DD-MM-YYYY HH[H]:mm:ss',
    time_form: 'HH:mm',
    pretty_date: "dddd DD MMMM YYYY",
    time: "HH[H]mm",
    today_at_time: "[Aujourd'hui à] HH[H]mm",
    tomorrow_at_time: "[Demain à] HH[H]mm",
    month: "MMMM",
    year: "YYYY",
    year_and_month: "YYYY MMMM",
    date_month_and_time: "DD/MM HH[H]mm"
  },
  SignInForm: {
    signin: "Se connecter",
    remember_me: "Se souvenir de moi",
    email: "Email",
    password: "Mot de passe",
    invalid_credentials: "Email ou mot de passe incorrect.",
    forgot_password: "Mot de passe perdu ?",
    go_to_signup_begin: "Pas encore de compte ? ",
    click_here: "Cliquez-ici ",
    go_to_signup_end: "pour vous inscrire avec un code établissement"
  },
  current_user: {
    signout: "Se déconnecter",
    edit_profile: "Mon profil",
    entities_profile: "Mes établissements",
    my_entities: "Mes établissements"
  },
  CandidateEntities: {
    title: "Mes établissements",
    pending_invitations: "Invitations en attente",
    profesional_inforamations: "Informations professionnelles",
    no_pending_invitation: "Pas de nouvelles invitations.",
    join_new_entity: "Rejoindre un nouvel établissement"
  },
  CandidateJoinEntities: {
    title: "Rejoindre un nouvel établissement",
    table_title: "Autres établissements",
    modal_button_add: "Rejoindre d'autres établissements du groupe",
    modal_button_modify: "Modifier",
  },
  CandidateSelectEntitiesModal: {
    already_registered: "Vous êtes déjà inscrit sur cet établissement"
  },
  ManagerEntities: {
    message_new_tag: "Félicitations ! Vous avez récemment rejoint la plateforme d'un ou plusieurs établissements"
  },
  users: {
    title_page: "Gérer mon équipe",
    active: "équipe",
    confirmed: "A valider",
    export: "Exporter",
    pending: "En attente candidat",
    no_data: "Aucun résultat n'a été trouvé",
    relaunch: "Relancer le candidat",
    already_relaunch: 'Ce candidat a déjà été relancé cette semaine',
    waiting_validation: "En attente de validation",
    messages: {
      remove_record: "Êtes-vous sûr de vouloir supprimer définitivement {userName} de votre équipe?",
      remove_service: "Êtes-vous sûr de vouloir supprimer {userName} de l'équipe de votre service {serviceName} ?",
      remove_services: "<div class='confirm-box-title'>Êtes-vous sûr de vouloir supprimer {userName} de l'équipe des services:</div> <div class='confirm-box-list'><ul>{servicesName}</ul></div>",
      refuse_member: "Êtes-vous sûr de vouloir supprimer ce candidat de votre équipe?",
      user_has_active_offers: "Cet utilisateur a des candidatures sur des demandes actives sur cet établissement, il est impossible de le supprimer."
    },
    search: {
      placeholder: 'Recherchez un nom, un prénom, un e-mail, un service ou un métier...',
      recherche_name: 'Recherchez un nom et/ou un prénom'
    },
    link_add_candidate: "Accéder au formulaire d'inscription candidat"
  },
  managers: {
    title_page: "Gérer mon équipe de direction",
    active: "équipe de direction",
    search: {
      placeholder: "Recherchez un nom, un prénom, un e-mail ou un service..."
    }
  },
  Occupations: {
    select_group: 'Sélectionnez l\'entité que vous souhaitez administrer',
    title_page: 'Gérer les métiers',
    name_placeholder: 'Nom du métier',
    group_tab: 'Pour le groupe',
    entity_tab: 'Pour un établissement',
    form: {
      edit: {
        title: 'Modifier le compte',
        fields: {
          name: 'Nom'
        }
      }
    },
    guideline: "Vous trouverez ci-dessous la liste des métiers que l'administrateur de votre groupe a configuré, activez celui ou ceux que vous souhaitez utiliser dans votre établissement.",
    messages: {
      deactivate_occupation_relates_users: "Ce métier est l'unique métier de certains utilisateurs, il est impossible de le désactiver.",
      deactivate_occupation_has_active_offers: "Ce métier est concerné par des demandes actives, il est impossible de le désactiver.",
      occupation_relates_users: "Ce métier est l'unique métier de certains utilisateurs, il est impossible de le supprimer.",
      occupation_has_acitve_offers: 'Ce métier est concerné par des demandes actives, il est impossible de le supprimer.'
    }
  },
  Offers: {
    title_page: 'Demandes',
    guideline: 'Cliquez sur une offre pour voir le détail',
    view_history: "Voir l'historique",
    by: 'par',
    status: {
      manager: {
        all: 'Toutes',
        published: 'En cours',
        waiting: 'A valider',
        draft: 'Brouillon',
        passed: 'Toutes',
        validated: 'Pourvues',
        expired: 'Toutes',
        expired_and_validated: 'Pourvues',
        expired_and_not_validated: 'Expirées',
        cancelled: 'Annulées'
      },
      candidate: {
        published: 'En cours',
        waiting: 'En attente',
        validated: 'A venir'
      }
    },
    filters: {
      entities: 'Établissement',
      services: 'Service de remplacement',
      services_replace: 'Service de rattachement',
      hubs: 'Pôle',
      occupations: 'Métier remplacé',
      published_by: 'Publiée par',
      export: 'Exporter',
      export_is_loading: 'Votre export est en train de charger.',
      reset: 'Réinitialiser'
    }
  },
  RequestHistories: {
    title: "Historique des demandes"
  },
  Offer: {
    candidate: 'Candidat',
    deleted_candidate: 'Ce candidat a été supprimé',
    title_page: 'Détail de la demande n° {number}',
    publish_at: 'Publiée le {date}',
    publish_at_by: 'Publiée le {date} par {publisher}',
    updated: 'Modifiée',
    date_and_name: 'le {date} par {publisher}',
    cancelled: 'Annulée',
    updated: "Modifiée",
    by: 'par',
    cancel_at: 'le {date}',
    decline: "Refuser le candidat",
    accept: "Accepter le candidat",
    see_historic: "Voir le détail",
    accept_at: "accepté le {date_time}",
    back: "Retour à la liste des demandes",
    delete_confirmation: "Etes-vous sûr de vouloir supprimer cette demande?",
    candidates: "candidats potentiels",
    refusingCandidates: "candidats ayant refusé",
    refusedCandidates: "Candidats non retenus",
    selected_candidates: "candidats sélectionnés",
    duplicate: "Dupliquer la demande",
    duplicate_confirmation: "Êtes vous sûr de vouloir dupliquer cette demande ?",
    candidate_overlap: "- ce candidat a été retenu pour un autre remplacement chevauchant la période.",
    send_to_staff: 'Diffuser une offre d\'emploi',
    edit_offer_contract: "Modifier infos contrats"
  },
  OfferInformation: {
    entity: "Etablissement: ",
    period: "Période: ",
    from_to: "Le {date} de {startAt} à {endAt} {durationTime}",
    hub_name: "Pôle: ",
    replaced_service: "Service: ",
    replaced_occupation: "Métier: ",
    searched_occupations: "Métier(s) recherchés: ",
    resource: "Ouvert aux candidats: ",
    details: "Informations complémentaires:",
    replacement_motive: 'Motif de remplacement:',
    waiting_validation: "Votre réponse a bien été transmise, elle est en attente de validation.",
    validated: "Votre candidature a été acceptée.",
    managers_in_copy: "Personne(s) en copie:",
    edit_comment: "Commentaire de la modification:",
    supp: "Supp",
    new: "new"
  },
  OfferCandidateInfo: {
    external_extra: "(Interne de : <strong>{entity}</strong>) | (Interne de : <strong>{entity}</strong> et 1 autre) | (Interne de : <strong>{entity}</strong> et {count} autres)",
    decline_confirmation: "Êtes-vous sûr de vouloir refuser ce candidat?",
    accept_at: "A postulé le {date_time}",
    validated_by: "Validé par {validator}",
    future_offers: "demandes à venir",
    future_offer: "demande à venir",
    passed_offers: "demandes réalisées",
    passed_offer: "demande réalisée",
    this_month: "Ce mois-ci",
    at_the_month_of: "Au mois de ",
    candidated_validated: "Ce candidat a été validé pour ce remplacement",
    candidated_cancelled: "Remplacement annulé. Le candidat a été notifié.",
    that_is: "soit",
    effective_work_not_complete: "Un ou plusieurs temps de travail effectif n'ont pas été renseigné sur les demandes. Cette information peut être incorrecte."
  },
  buttons: {
    add: 'Ajouter',
    add_multiple: 'Ajouter en masse',
    modif_and_validate: 'Modifier et valider le candidat',
    validate: 'Valider',
    cancel: 'Annuler',
    confirm: 'Confirmer',
    yes: 'OUI',
    no: "NON",
    save: 'Sauvegarder',
    reject: 'Supprimer',
    change_password: 'Modifier le mot de passe',
    not_available: 'Pas dispo',
    accept: "J'accepte",
    see_more: 'Voir plus'
  },
  table: {
    headers: {
      name: 'Nom',
      first_name: 'Prénom',
      email: 'Adresse email',
      coordinates: "Coordonnées",
      mobile_phone: 'Téléphone mobile',
      home_phone: 'Téléphone fixe',
      phone: 'Téléphone',
      service: 'Service de remplacement',
      services: 'Service(s) de remplacement',
      occupation: 'Métier',
      internal: 'Interne',
      provider_id: 'Matricule',
      actions: 'Actions',
      activer: 'Activer',
      contract: 'Contrat',
      payment_mode: 'Type de rémunération',
      offer_begin_datetime: 'Date et heure de début',
      offer_end_datetime: 'Date et heure de fin',
      created_at: 'Crée le',
      by: 'Par',
      published_at: 'Publiée le',
      entity: 'Etablissement',
      hub: 'Pôle',
      candidate: 'Candidat',
      candidates: 'Candidats',
      affiliation_service: 'Service de rattachement',
      occupations: 'Métier(s)',
      candidate_entity_internal: "INTERNE (salarié de l'établissement)",
      replacement_motive: 'Motif',
      connecting_service: "Service de rattachement",
      week: 'Semaine',
      accumulation_of_hours: "Cumul H Mois",
      year: 'Année'

    }
  },
  yes: 'oui',
  no: 'non',
  actions: {
    add: 'Ajouter',
    add_bulk: 'Ajouter en masse',
    cancel: 'Annuler',
    update: 'Modifier',
    delete: 'Supprimer',
    save: 'Valider'
  },
  Services: {
    manage_services: 'Gérer les services',
    hubs: 'Pôles',
    services: 'Services'
  },
  ServiceTable: {
    name: 'Nom',
    actions: 'Actions'
  },
  ServiceRow: {
    undeletable_notice_offer: 'Ce service est concerné par des demandes actives, il est impossible de le supprimer.',
    undeletable_notice_user: "Ce service est l'unique service de certains utilisateurs, il est impossible de le supprimer."
  },
  ServiceForm: {
    name_placeholder: 'Nom du service'
  },
  ServiceHubTable: {
    name: 'Nom',
    actions: 'Actions'
  },
  ServiceHubForm: {
    name_placeholder: 'Nom du service',
    hub: 'Pôle'
  },
  HubTable: {
    name: 'Nom',
    actions: 'Actions'
  },
  HubForm: {
    name_placeholder: 'Nom du pôle'
  },
  HubRow: {
    no_service: "Il n'y a pas de service correspondant"
  },
  OfferCandidateDetail: {
    published_at_title: "Publié le {date} par {name}"
  },
  DisturbStatus: {
    active_not_disturb: 'Activer le mode ne pas déranger',
    actived_not_disturb: "Mode ne pas déranger activé jusqu'au {date}"
  },
  NotDisturbMode: {
    title: "Activer le mode \"ne pas déranger\"",
    first_describe: "Le mode \"ne pas déranger\" vous permet de ne pas recevoir d'alertes (mails, sms et notifications push) jusqu'à la date que vous sélectionnerez ci dessous",
    second_describe: "Je ne souhaite pas recevoir de demandes de remplacement jusqu'au:"
  },
  EditProfile: {
    title: 'Mon profil',
    tip: 'Si vous souhaitez modifier vos informations personnelles, merci de contacter votre manager ou votre interlocuteur RH.',
    information_personal: 'Informations personnelles',
    information_professional: 'Informations professionnelles',
    change_password_title: 'Changer mon mot de passe',
    password_note: '8 caractères minimum',
    id: 'Matricule',
    old_password: 'Ancien mot de passe',
    new_password: 'Nouveau mot de passe',
    password_confirmation: 'Confirmer le mot de passe',
    notificationSms: 'Activer les notifications par SMS',
  },
  UserNoticePreferences: {
    contact_me_when: 'Me contacter quand...',
    by_email: 'Par e-mail',
    by_mobile_notification: 'Par notification mobile',
    by_sms: 'Par SMS',
    recruiter_application_waiting: "Quand j'ai une candidature à valider",
    recruiter_validate_subscription: "Quand le compte d'un candidat est en attente de validation",
    candidate_cancel_offer: "Quand mon remplacement est annulé",
    candidate_interresting_offer: "Quand je reçois une demande",
    candidate_application_accepted: "Quand ma candidature est acceptée",
    candidate_application_refused: "Quand ma candidature est refusée",
    candidates_apply_other_service: "Quand un candidat d'un service ci-dessous se positionne sur un autre service",
    candidates_validates_other_service: "Quand un candidat d'un service ci-dessous est validé sur un autre service",
    recruiter_offer_cancelled_in_service: "Quand une demande d'un service ci-dessous est annulée"
  },

  messages: {
    no_data: 'Aucune donnée à afficher',
    password_updated: 'Votre mot de passe a bien été mis à jour',
    password_update_failed: 'La réinitialisation de votre mot de passe a échoué, nous vous prions de bien vouloir  réessayer ou de contacter le support technique.',
    required_field: '{fieldName} est obligatoire.',
    required_field_popup: 'Ce champ est obligatoire.',
    create_success: 'Le {resource} {name} a été créé avec succès',
    update_success: 'Le {resource} {name} a été mis à jour avec succès',
    delete_confirmation: 'Confirmez-vous la suppression du {resource} {name} ?',
    delete_success: 'Le {resource} {name} a été supprimé avec succès',
    delete_failure: "Le {resource} {name} n'a pas été supprimé",
    offer_accepted: 'Candidature acceptée',
    offer_declined: 'Candidature refusée',
    user_active_success: '{name} a bien été ajouté à votre équipe.',
    user_create_success: 'Le compte de {name} a bien été créé',
    user_update_success: 'Le compte de {name} a bien été modifié',
    offer_deleted: 'La demande a bien été supprimée',
    offer_refused: 'Votre refus a bien été pris en compte',
    offer_applied: 'Votre candidature a bien été envoyée.',
    user_delete_success: '{name} a bien été supprimé de votre équipe',
    user_recall_success: '{name} a bien été relancé',
    user_recall_error: 'Une erreur est survenue lors de la relance de {name}',
    offer_shared: "Cette offre a bien été partagée",
    offers: {
      published_success: "La demande a été publiée avec succès",
      saved_draft_success: "La demande a bien été enregistrée",
      update_success: "La demande a bien été enregistrée",
      cant_edit_published_offer: "Vous ne pouvez pas modifier cette offre"
    },
    hubs_delete_to_note: "À noter : la suppression du pôle n'entraîne pas la suppression des services qui lui sont rattachés.",
    time_code_delete_success: 'Le code horaire a été supprimé',
    cannotAccess: "Votre statut ne vous permet pas d'accéder à cet écran",
    offer_sent_to_staff: "Votre offre a été transmise à notre équipe, elle sera diffusée prochainement."
  },
  version: {
    outdated: {
      first: 'Votre plateforme a été mise à jour. Merci de',
      link: 'cliquer-ici',
      second: 'afin de rafraîchir votre page.',
    }
  },
  form: {
    forgot_password: {
      main_guide_line: "Veuillez saisir l'adresse email associée à votre compte.",
      sub_guide_line: "Nous vous enverrons un lien par email pour créer un nouveau mot de passe.",
      validate_email: "Saisissez votre mot email",
      button: "Envoyer le lien de réinitialisation",
      title: "Mot de passe oublié"
    },
    reset_password: {
      title: 'Paramétrage du mot de passe',
      password_confirmation: 'Confirmation mot de passe'
    },
    update_information: {
      title: 'Vérification des informations',
      button: 'Valider mes informations',
      dialog: 'En confirmant vos informations, vous serez redirigé vers la page de connexion et ne pourrez vous connecter qu\'après validation de votre manager'
    }
  },
  resources: {
    occupation: 'métier',
    service: 'service',
    user_profile: 'profil',
    timeCode: 'code horaire',
    hub: 'pôle'
  },
  Managers: {
    title: "Gérer mon équipe de direction",
    add: "Ajouter"
  },
  NewManager: {
    title: "Ajout d'un membre de l'équipe dirigeante dans mon équipe"
  },
  UserForm: {
    cancel: "Annuler",
    submit: "Valider",
    establishment: 'Établissement',
    add_to_other_establishments: "Ajouter sur d'autres établissements",
    notice_blue: "Ce candidat utilise déjà PERMUTEO. Si ses informations ne sont pas à jour, vous pourrez les modifier par la suite.",
    notice_red: "Ce candidat est déjà inscrit dans votre établissement",
    notice_manager_blue: "Ce manager utilise déjà PERMUTEO. Si ses informations ne sont pas à jour, vous pourrez les modifier par la suite.",
    notice_manager_red: "Ce manager est déjà inscrit dans votre établissement",
    candidate_attached_to_entity: "Ce candidat est déjà inscrit dans cet établissement",
    candidate_confirm_requirement: 'Le compte de ce candidat est en cours de création sur une autre plateforme, veuillez réessayer plus tard.',
    addon_title: "Ajouter le candidat sur d'autres établissements du groupe",
    addon_manager_title: "Ajouter le manager sur d'autres établissements du groupe",
    information_personal: 'Informations personnelles',
    offer_history: 'Historique des remplacements',
    availability: 'Disponibilités',
    planning: 'Planning',
    validated_by: 'Candidat validé par',
    added_by: 'Candidat ajouté par',
    email_taken: 'Cet email est déjà pris',
    delete_confirmation: 'Êtes-vous sûr de ne pas vouloir effectuer de remplacements dans cet établissement ?',
    other_entities: "autres établissements",
    modify_button: "Modifier",
    contract_title: 'Infos contrat',
    contract_message: 'Les informations suivantes sont nécessaires pour la génération des contrats. Si vous le souhaitez, vous pouvez les laisser vierge pour l\'instant, elles seront alors redemandées lors de la génération du premier contrat pour ce candidat.',
    unavailability_dates_provider_id: "Numéro de matricule ({scope})",
    scopes: {
      entity: 'Établissement {name}',
      corporation: 'Groupe {name}'
    }
  },
  NewUser: {
    title: "Ajout d'un membre de mon équipe"
  },
  EditUser: {
    title: "Modification d'un membre de mon équipe",
    editServiceInfo: "Si vous souhaitez modifier les services des membres de votre vivier, merci de consulter votre interlocuteur RH."
  },
  NewOffer: {
    title: "Créer une demande de remplacement"
  },
  EditOffer: {
    title: "Modifier une demande de remplacement"
  },
  EditOfferContract: {
    title: "Modifier une demande de remplacement",
    confirm: "Attention, si vous aviez déjà validé le contrat pour cette demande, vous devrez le recréer afin de voir les modifications effectuées",
  },
  OfferForm: {
    my_offers: "Mes services",
    all_offers: "Tous les services",
    buttons: {
      save_draft: "Enregistrer en brouillon",
      publish: "Publier l'offre",
      re_publish: "Republier"
    },
    nav: {
      form: "Création de demande",
      select: "Sélection des candidats"
    },
    for_intern_only: "Pour les internes uniquement",
    no_occupation: "Il n'y pas de métier correspondant",
    no_service: "Il n'y a pas de service correspondant",
    no_coworkers: "Personne ne correspond",
    contract_title: 'Infos contrat',
    contract_message: 'Les informations suivantes sont nécessaires pour la génération des contrats. Si vous le souhaitez, vous pouvez les laissez vierges pour l\'instant, elles vous seront alors redemandées lors de la génération du contrat pour cette demande.'
  },
  OfferSharingForm: {
    no_manager: "Il n'y a pas de personnes correspondant",
    title: "Envoyer cette offre à:",
    buttons: {
      send: "Envoyer"
    }
  },
  RepublishOfferConfirmation: {
    title: 'Mettre à jour la demande et envoyer la notification a(ux)',
    all: 'Tous les candidats sélectionnés',
    new_concerned_candidate: 'Nouveaux candidats sélectionnés',
    none: 'Personne'
  },
  PublishOfferWithoutCandidateConfirmation: {
    title: 'Aucun candidat n’est sélectionné dans votre demande.',
    question: 'Souhaitez-vous la publier ?',
    confirm: 'Oui',
    abort: 'Non'
  },
  TimeCodes: {
    title_page: "Gérer les codes horaires",
    undeletable_notice_offer: "Ce code horaire est concerné par des demandes actives, il est impossible de le supprimer."
  },
  NewTimeCode: {
    title_page: "Créer un nouveau code horaire",
  },
  EditTimeCode: {
    title_page: "Modifier un code horaire",
  },
  models: {
    user: {
      last_name: "Nom",
      first_name: "Prénom",
      email: "Mail",
      phone: "Téléphone",
      mobile_phone: "Téléphone mobile",
      password: "Mot de passe",
      confirm_password: "Confirmation du mot de passe",
      role: "Fonction",
      affiliated_service: "Service de rattachement",
      services: "Service(s) de remplacement",
      alert_multi_choice_services: "VOUS POUVEZ SELECTIONNER PLUSIEURS SERVICES DE REMPLACEMENT",
      occupations: "Métier",
      hubs: "pôle(s)",
      entity_code: "Code établissement",
      home_phone: "Téléphone à domicile",
      roles_options: {
        super_admin: "Super Admin",
        admin: "Admin",
        recruiter: "Recruiter",
        candidate: "Candidate"
      },
      internal: "Interne",
      matricule: "Matricule",
      unavailability_dates_provider_id: "Numéro de matricule",
      civility: "Civilité",
      mrs: 'Madame',
      mr: 'Monsieur',
      birthdate: "Date de naissance",
      birthplace: "Lieu de naissance",
      address: "Adresse",
      social_security_number: "N° de sécurité sociale",
      salary_category: "Catégorie de rémunération",
      salary: "Rémunération",
      n_dpae: "N°DPAE",
      error_email: "Votre email semble mal orthographié. Voulez-vous dire ",
      no_accents_error: "Les accents et les caractères spéciaux ne sont pas autorisés dans l'adresse e-mail."
    },
    offer: {
      replaced_occupation: "Métier concerné par la demande de remplacement",
      searched_occupations: "Métier(s) recherché(s)",
      replaced_service: "Pour le service",
      potential_candidates: "candidat(s) potentiel(s)",
      period: "Période",
      details: "Modalités",
      resource_type: "Ouvert aux candidats",
      resources: {
        extern: 'externes',
        intern: 'internes du service concerné',
        intern_of_concerned_hub: 'internes du pôle concerné',
        intern_with_proposed_candidates: 'internes validés pour le service concerné',
        all: 'tous'
      },
      time_code: "Code horaire",
      effective_work_minutes: "Temps de travail effectif",
      mode: 'Mode',
      modes: {
        quick_mode: 'Mode rapide',
        choice_mode: 'Mode choix'
        },
      create_offers_for_each_period: "Diviser l'offre pour chaque période",
      include_proposed_candidates: "Proposer aux candidats validés pour le service",
      include_hub_services: "Proposer aux candidats des services du pôle",
      replacement_motive: "Motif de remplacement",
      replacement_motive_detail: "Détail du motif de remplacement",
      person_in_copy: "Personne(s) en copie",
      not_visible_by_candidate: "(non visible par le candidat)",
      replaced_person: "Personne remplacée",
      replaced_person_salary_category: "Catégorie de rémunération (personne remplacée)",
      replaced_person_salary: "Rémunération",
      hub: "Dans le pôle",
      service_dont_match_with_hub: "Attention le service sélectionné ne correspond pas au pôle choisi !",
      edit_comment: "Commentaire de la modification"
    },
    time_code: {
      name: "Nom",
      start_time: "Heure de début",
      end_time: "Heure de fin",
      effective_work_minutes: "Temps de travail effectif"
    },
    resource_types: {
      intern: "Internes du service concerné",
      intern_of_concerned_hub: 'Internes du pôle concerné',
      intern_with_proposed_candidates: 'Internes validés pour le service concerné',
      extern: "Externes",
      all: "Tous"
    },
    resource_type: {
      intern: "Interne",
      extern: "Externe"
    }
  },
  multiselect: {
    select_label: 'Appuyez sur Entrée pour sélectionner',
    placeholder: "Entrez les premières lettres",
    placeholder_hubs: "Filtrer par pôles",
    no_result: 'Pas de résultat pour cette recherche',
    max_options: 'Vous de pouvez pas sélectionner plus de 4 personnes à mettre en copie.',
    civility: 'Madame/Monsieur'
  },
  SignUpForm: {
    accept_CGU: "J'accepte les CGU",
    accept: "J'accepte les",
    cgu_link: "CGU",
    usage_policy_url: "et la charte d'utilisation de l'établissement",
    register: "Valider l'inscription",
    error_registering: 'Erreur lors de l\'inscription.',
    formSubmitted: 'Votre candidature a bien été transmise aux cadres de votre établissement, vous serez recontacté une fois celle-ci validée ou refusée. Merci !',
    label_internal: "INTERNE (salarié de l'établissement)",
    email_unique_pending: "Vous avez déjà été pré-inscrit par un cadre de votre établissement. Nous vous invitons à consulter votre boîte de réception, un mail d'invitation vous a été envoyé.",
    email_unique_not_pending: "Cet email est déjà utilisé.<br>S'il s'agit de votre compte, rendez-vous dans votre profil pour vous inscrire à un nouvel établissement.",
    send_me_email: "Me renvoyer le mail",
    go_to_signin_begin: "Déjà inscrit ? ",
    click_here: "Cliquez-ici ",
    go_to_signin_end: "pour vous connecter",
    email_sended: "Un email d'inscription vient de vous être renvoyé. Merci de vérifier votre boîte mail et de cliquer sur le lien pour compléter votre inscription.",
    buttons: {
      validate: "Valider",
      cancel: "Annuler"
    },
    add_to_other_establishments: "M'inscrire sur d'autres établissements",
    addon_title: "M'inscrire sur d'autres établissements du groupe {corporationName} :"
  },
  SignUpConfirmation: {
    message_beggining: "Vos informations ont bien été enregistrées et sont ",
    message_middle: "en attente de validation définitive ",
    message_end: "de la part du responsable du service.",
    receive_email_activated: "Vous recevrez un e-mail lorsque votre compte sera activé.",
    link_application: "En attendant, gagnez du temps et n'hésitez pas à télécharger notre application !"
  },
  CandidateSignUpFormSidebar: {
    accept_CGU: "Je confirme avoir avoir rempli ce formulaire avec le candidat et que celui-ci accepte <a target='blank' href='{url}' class='text-decoration-underline'>les CGU.</a>",
    label_internal: "INTERNE (salarié de l'établissement)"
  },
  tab: {
    see_offers: "Voir mes demandes",
    create_offer: "Créer une demande",
    manage_team: "Gérer mon équipe",
    manage_services: "Gérer les services",
    manage_occupations: "Gérer les métiers",
    manage_managers: "Gérer les managers",
    manage_time_codes: "Gérer les codes horaires",
    stats: "Statistiques",
    unavailability_calendar: "Saisir mes indisponibilités",
    parameters: "Paramétrage"
  },
  status: {
    candidate: "candidat",
    recruiter: "manager",
  },
  stats: {
    offers_between: "Demandes commençant entre le"
  },
  candidate: {
    number: 'candidat(s)',
    potential_candidates: "candidat(s) potentiel(s)",
    selected_candidates: "candidat(s) sélectionné(s)"
  },
  UnavailabilityCalendar: {
    add_datetime: "Ajouter une période d'indisponibilité",
    full_day: "Journée entière",
    specific_times: "Horaires spécifiques",
    several_days: "Plusieurs jours",
    only_date: "Le",
    start_date: "Du",
    end_date: "Au",
    start_time: "De",
    end_time: "à",
    time_invalid: "L'heure de début doit être avant l'heure de fin.",
    date_invalid: "La date de début doit être avant la date de fin."
  },
  UnavailabilityHelper: {
    info: "Pour renseigner une période d'indisponibilité, ou voir le détail de vos indisponibilités déjà renseignées, cliquez sur la date correspondante. Vous ne recevrez pas de demandes de remplacement pour les périodes auxquelles vous êtes indisponible.",
    personal_whole_day: 'indisponibilité personnelle (journée entière)',
    personal: 'indisponibilité personnelle',
    validated_replacement: 'remplacement PERMUTEO validé',
    ts_planner: 'planning professionnel'
  },
  OfferPeriodsForm: {
    add_new_period: 'Ajouter une période',
    create_one_offer: "créer une demande de remplacement concernant toutes les périodes saisies",
    create_offers_for_each_period: "créer une demande de remplacement par période saisie"
  },
  OfferPeriodRow: {
    from: 'Le',
    time_code: 'Code horaire',
    at: 'de',
    to: 'à',
    effective_work_minutes: 'temps de travail',
    delete_confirmation: 'Êtes-vous sûr de vouloir supprimer cette période?'
  },
  CandidatePlanning: {
    title: "Planning du candidat",
    unavailable: "Indisponible",
    from_to: "Du {start} au {end}",
  },
  Statistic: {
    BtnShowMoreLess: {
      see_less: 'Voir moins',
      see_more: 'Voir tout'
    },
    title: 'Statistiques',
    tabs: {
      period_report: 'Mon rapport périodique',
      global: {
        title: 'Activité globale',
        sections: {
          activity_candidate: {
            title: 'Activité sur la plateforme'
          },
          using_channels: {
            title: 'Utilisation des canaux',
            num_candidates_using_app: 'candidats utilisent l’application PERMUTEO',
            num_manager_using_app: "cadres soignants utilisent l'application PERMUTEO",
            num_offer_sms: 'demandes de remplacement acceptées par SMS'
          },
          evolution: {
            title: 'Évolution du vivier'
          }
        }
      }
    },
    general: {
      number_part: {
        text: 'demandes de remplacement envoyées'
      }
    },
    filters: {
      title: 'Filtrer par :',
      date_range_types: {
        next_month: 'Mois à venir',
        current_month: 'Mois en cours',
        last_month: 'Mois passé',
        last_quarter: 'Trimestre passé',
        last_year: 'Année passée'
      }
    },
    sections: {
      general: {
        title: 'Général'
      },
      time_response: {
        title: 'Délai de réponse',
        content: 'La moitié des demandes de remplacement trouvent un candidat en moins de',
      },
      distribution_of_requests: {
        title: 'Répartition des demandes'
      },
      replacements: {
        title: 'Motifs de remplacement'
      },
      top_candidate: {
        title: 'Top candidats'
      },
    }
  },
  PopupNewFeature: {
    title: "Votre plateforme PERMUTEO évolue !",
    btn_ok: "OK, j'ai compris",
    btn_cancel: "Me le rappeler plus tard"
  },
  OfferCancelForm: {
    title: "Êtes-vous sûr de vouloir annuler cette demande ?",
    message: "Vous pouvez également laisser un commentaire dans le champ ci-dessous.",
    note: "*Ce commentaire ne sera pas envoyé au candidat.",
    buttons: {
      confirm: "Confirmer l'annulation",
      close: "Fermer"
    }
  },
  SelectEntity: {
    label: "Sélectionnez l'établissement que vous souhaitez administrer : "
  },
  SelectContractForm: {
    title: "Choisissez un modèle :",
    no_data: "Les modèles de contrats de votre établissement n'ont pas encore été configurés. En cas de problème, veuillez nous contacter au 03 20 32 60 22.",
    buttons: {
      confirm: "Valider",
      close: "Annuler"
    }
  },
  OfferContract: {
    title: "Contrat de remplacement",
    buttons: {
      add_offer: "Ajouter une demande",
      generate_contract: "Générer le contrat",
      validate: "Valider"
    },
    missingFields: {
      candidate: "Certaines informations concernant le <strong>candidat</strong> sont manquantes, merci de les compléter afin de pouvoir générer le contrat :",
      offer: "Certaines informations concernant la <strong>demande</strong> sont manquantes, merci de les compléter afin de pouvoir générer le contrat :",
      multiple_offer_variable_message: '(cette valeur sera utilisée pour <span style="color: red;">l\'ensemble des demandes</span> du contrat)'
    },
    update_fields_button: "Mettre à jour les informations"
  },
  Contract: {
    title: "Contrat de remplacement",
    pageButtons: "page"
  },
  Contract: {
    title: "Contrat de remplacement",
    validate: "Valider le contrat",
    applySignature: "Appliquer la signature numérique de la direction",
    cancel: "Annuler",
    pageButtons: "page",
    sign: "Signer le contrat",
    deleteConfirm: "Êtes-vous sûr de vouloir supprimer le contrat ?",
    signConfirm: "Êtes-vous sûr de vouloir signer le contrat ?"
  },
  ContractStep: {
    steps: {
      close: "Fermer"
    },
    step: {
      prefix: 'Suivi :',
      date: '- {date}'
    },
    add: "Ajouter un suivi",
    showSteps: "Voir tout",
    placeholder: "Contrat imprimé",
  },
  DashboardPageManager: {
    menu_links: {
      create_offer: "Créer une demande",
      create_candidate: "Ajouter un candidat",
      conseils_rh: "Lire les articles RH",
      contact_support: "Contacter le support"
    },
    InformationBlock: {
      current_week: {
        title: 'Cette semaine',
        buttons: {
          view_stats: 'Voir les stats'
        }
      },
      user_kit: {
        title: 'Kit utilisateur',
        tutorials: 'Tutoriels',
        communication: 'Communication',
        article: 'Articles RH',
        faq: 'FAQ'
      },
      my_profile: {
        title: 'Mon profil',
        mail: 'Mail',
        telephone: 'Téléphone'
      }
    },
    AwaitingCandidateBlock: {
      admin_title: 'Candidats en attente',
      recruiter_title: 'Nouveaux candidats',
      confirmed_title: 'À valider',
      actived_title: 'Validés récemment',
      pending_title: 'À relancer',
      choose_entity: 'Sélectionnez un établissement pour voir le détail.',
      buttons: {
        view_all: 'Voir tout'
      }
    },
    AwaitingCandidateProgressBlock: {
      actived: 'Validés',
      pending: 'En attente candidat',
      confirmed: 'À valider'
    },
    AwaitingPopupCandidateDetail: {
      btn_edit: 'Éditer le profil',
      btn_validate: 'Valider le candidat'
    },
    block_first_title: "Prochaines demandes",
    my_requests: "Mes demandes",
    all: "Toutes",
    beginning: "début",
    waiting: "À valider"
  },
  pagination: {
    previous: 'Préc',
    next: 'Suiv'
  },
  UserMultiAction: {
    select_all: 'Tout cocher',
    deselect_all: 'Tout décocher',
    activate: 'Ce candidat est en attente de validation sur plusieurs de vos établissements. Sélectionnez ceux sur lesquels vous souhaitez le valider :',
    delete: 'Ce candidat est présent sur plusieurs de vos établissements. Sélectionnez ceux sur lesquels vous souhaitez le supprimer :',
    refuse: "Ce candidat est inscrit sur plusieurs de vos établissements. Sélectionnez ceux sur lesquels vous ne souhaitez pas l'intégrer :",
    manager: {
      delete: 'Ce manager est présent sur plusieurs de vos établissements. Sélectionnez ceux sur lesquels vous souhaitez le supprimer :'
    }
  },
  UserKit: {
    user_kit: "Kit utilisateur",
    tutorials: "Tutoriels",
    communication: "Communication",
    user_guides: "Guides d'utilisation",
    tutorials_tab: {
      manager: {
        destination_managers: "À destination des administrateurs et managers",

        understanding_dashboard: "Comprendre mon tableau de bord PERMUTEO",
        how_create_manager: "Comment créer mon compte manager ?",
        how_create_replacement: "Comment créer une demande de remplacement ?",
        how_select_candidates_in_offer: "Comment sélectionner des candidats à la création d'une demande ?",
        how_manage_replacement: "Comment gérer mes demandes de remplacement ?",
        how_respond_application: "Comment répondre à une candidature ?",
        how_add_candidate_to_team: "Comment ajouter un candidat à mon équipe ?",
        how_manage_team: "Comment gérer mon équipe ?",
        how_check_candidate_schedule: "Comment vérifier le planning d'un candidat ?",
        how_analyze_statistics: "Comment analyser mes statistiques ?"
      },
      candidate: {
        destination_candidate: "À destination des candidats",

        how_register: "Comment m'inscrire ?",
        how_manage_agenda: "Comment gérer mon agenda ?",
        how_manage_solicitation_preferences: "Comment gérer mes préférences de sollicitation ?",
        how_accept_or_refuse_replacement: "Comment accepter ou refuser une demande de remplacement ?",
        how_logout: "Comment me déconnecter ?",
        how_change_password: "Comment changer mon mot de passe ?"
      }
    },
    communication_tab: {
      destination_managers: "À Destination des managers",
      description_video: "Vidéo de présentation: pourquoi utiliser PERMUTEO ?",
      destination_candidate: "À Destination des candidats",
      description_poster: "Affiche PERMUTEO: diffuser le code établissement",
      description_flyer: "Flyer PERMUTEO: comprendre la solution en quelques minutes!",
      code_entity: "Quel est mon code établissement ?"
    },
    user_guides_tab: {
      coming_soon: 'coming soon',
      message: "Retrouvez très prochainement les guides d'utilisation complets de la plateforme PERMUTEO, pour répondre à vos interrogations et celles de vos candidats."
    }
  },
  OfferSendToStaff: {
    form: {
      replaced_occupation: 'Métier',
      job_presentation: 'Présentation du poste',
      searched_profile: 'Profil recherché',
      required_experience: 'Expérience requise',
      qualification: 'Diplôme',
      location: 'Localisation',
      work_time: 'Temps de travail',
      publish: "Publier l'offre",
      application_recipient: 'Destinataire des candidatures'
    },
    unexperienced: 'Aucune expérience',
    junior: "Débutant (moins de 2ans)",
    experienced: "Expérimenté (2 à 5 ans)",
    senior: "Confirmé (5ans et plus)",
    full_time: 'Temps plein',
    part_time: 'Temps partiel',
    title: "Diffuser une offre d'emploi"
  },
  PopupMultipleOffers: {
    btn_ok: 'Ok',
    btn_cancel: 'Annuler',
    info_message_1: 'Attention, lors de la génération du contrat, les informations suivantes seront celles de <span style="color: red;">la première demande que vous avez sélectionné</span>:',
    info_message_2: 'Merci de vérifier que ces informations sont valables pour l\'ensemble des demandes que vous ajoutez au contrat.'
  },
  UserEntity: {
    decline_confirm: "Êtes-vous sûr de vouloir refuser cette invitation ?"
  },
  ServicesFieldGroupByHub: {
    selectAll: "Tout cocher",
    deselectAll: "Tout décocher"
  }
};

export default fr



// WEBPACK FOOTER //
// ./src/lang/fr.js